import {Injectable} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";


@Injectable()
export class ToastService {

    constructor(private toastr: ToastrService, private translate: TranslateService) {
    }

    public get(): ToastrService {
        return this.toastr;
    }
    public  success(message, title?) {
        this.toastr.success(message, title? title : "Sucesso");
    }

    public onError(error, message?) {
        console.log(error);
        if(error.statusCode % 400 >= 100) {
            this.toastr.error(this.translate.instant(!message ? "alert.internal_server_error" : message), this.translate.instant("alert.error"));
        } else if(error.statusCode == 404) {
            this.toastr.warning(this.translate.instant(!message ? "alert.not_found" : message), "404");
        } else {
            error.error.errors.forEach(error => {
                this.toastr.warning(this.translate.instant('alert.' + error.toLowerCase()), this.translate.instant("alert.error"));
            });
        }
    }

}